import { blockedwordConstants } from '../constants';

const initialState = {
    loading: false,
    blockedwords: [],
    error: null,
    creatingBlockedword: false,
    createError: null,
    updatingBlockedword: false,
    updateError: null,
};

const blockedwordReducer = (state = initialState, action) => {
    switch (action.type) {
        case blockedwordConstants.FETCH_BLOCKEDWORDS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case blockedwordConstants.FETCH_BLOCKEDWORDS_SUCCESS:
            return {
                ...state,
                loading: false,
                blockedwords: action.blockedwords,
                error: null
            };
        case blockedwordConstants.FETCH_BLOCKEDWORDS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case blockedwordConstants.CREATE_BLOCKEDWORD_REQUEST:
            return {
                ...state,
                creatingBlockedword: true,
                createError: null,
            };
        case blockedwordConstants.CREATE_BLOCKEDWORD_SUCCESS:
            return {
                ...state,
                creatingBlockedword: false,
                blockedwords: action.blockedwords,
            };
        case blockedwordConstants.CREATE_BLOCKEDWORD_FAILURE:
            return {
                ...state,
                creatingBlockedword: false,
                createError: action.payload,
            };

        case blockedwordConstants.UPDATE_BLOCKEDWORD_REQUEST:
            return {
                ...state,
                updatingBlockedword: true,
                updateError: null,
            };
        case blockedwordConstants.UPDATE_BLOCKEDWORD_SUCCESS:
            return {
                ...state,
                blockedwords: action.blockedwords,
                updatingBlockedword: false,
                updateError: null,
            };
        case blockedwordConstants.UPDATE_BLOCKEDWORD_FAILURE:
            return {
                ...state,
                updatingBlockedword: false,
                updateError: action.payload,
            };
        case blockedwordConstants.DELETE_BLOCKEDWORD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case blockedwordConstants.DELETE_BLOCKEDWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                blockedwords: state.blockedwords.filter(b => b.WordID !== action.payload),
            };
        case blockedwordConstants.DELETE_BLOCKEDWORD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default blockedwordReducer;
